"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShapeDiverArSceneApi = void 0;
const sdk_geometry_api_sdk_core_1 = require("@shapediver/sdk.geometry-api-sdk-core");
const utils_1 = require("../utils/utils");
class ShapeDiverArSceneApi extends sdk_geometry_api_sdk_core_1.BaseResourceApi {
    constructor(api) {
        super(api);
    }
    exists(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, utils_1.sendRequest)(() => __awaiter(this, void 0, void 0, function* () {
                try {
                    const [_, status] = yield this.api.head(`${this.buildArSceneUri()}/${id}`, { disableAuthorization: true });
                    return status === 200;
                }
                catch (e) {
                    if (e instanceof sdk_geometry_api_sdk_core_1.ShapeDiverResponseError && e.status === 404)
                        return false;
                    else
                        throw e;
                }
            }));
        });
    }
    getGltf(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, utils_1.sendRequest)(() => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const [header, data] = yield this.api.get(`${this.buildArSceneUri()}/${id}/gltf`, undefined, {
                    responseType: sdk_geometry_api_sdk_core_1.ShapeDiverSdkApiResponseType.DATA,
                    disableAuthorization: true,
                });
                const contentType = (_a = header["Content-Type"]) !== null && _a !== void 0 ? _a : header["content-type"];
                return [data, contentType];
            }));
        });
    }
    getUsdz(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, utils_1.sendRequest)(() => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const [header, data] = yield this.api.get(`${this.buildArSceneUri()}/${id}/usdz`, undefined, {
                    responseType: sdk_geometry_api_sdk_core_1.ShapeDiverSdkApiResponseType.DATA,
                    disableAuthorization: true,
                });
                const contentType = (_a = header["Content-Type"]) !== null && _a !== void 0 ? _a : header["content-type"];
                return [data, contentType];
            }));
        });
    }
}
exports.ShapeDiverArSceneApi = ShapeDiverArSceneApi;
//# sourceMappingURL=ShapeDiverArSceneApi.js.map